
import * as yup from "yup";

const phoneRegex = /^(\+\d{1,2}\s?)?1?-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;

export const prodregSchema = yup.object().shape({
  fname: yup.string().max(20, "charater limit 20").required("First Name is required"),
  lname: yup.string().max(20, "charater limit 20").required("Last Name is required"),
  city: yup.string().required("City is required"),
  state: yup.string().required("State or territory is required"),
  zip: yup.string().required("Postal code is required"),
  phone: yup.string().matches(phoneRegex,{ message: "Not a valid phone" }),
  model: yup.string().required("Model is required"),
  size: yup.string().required("Size is required"),
  store: yup.string().required("Store is required"),
  serialNo: yup.string().min(8).required("Serial No is required"),
  dateOfPurchase: yup.string().required("Date of purchase is required"),
  captcha: yup.string().required("Please verify that you are not a robot"),
  receipt: yup.mixed().test("is-valid-size", "Max allowed size is 100MB",value => !value || (value && value.size <= 100000000))
});